import React, { useEffect, useState } from "react";
// import { deleteLeadAttachment } from "../../../../../../api/lead";
import { Typography } from "@mui/material";
import FilePreviewModal from "./file-preview-modal";
import { deleteGuide } from "../../../api/guides";
import AttachmentActionsMenu from "./attachment-actions-menu";
import { ConfirmationPopup } from "../../../common/components";

interface AttachmentActionsProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  type: "LINK" | "FILE";
  item: any;
  fetchGuidesData: any;
  setLoading: any;
  setAlertMessage: any;
  setAlertType: any;
  setAlertOpen: any;
  disableEdit?: boolean;
  isSuperTenant?: boolean;
}

const AttachmentActions: React.FC<AttachmentActionsProps> = ({
  open,
  anchorEl,
  onClose,
  type,
  item,
  fetchGuidesData,
  setLoading,
  setAlertMessage,
  setAlertOpen,
  setAlertType,
  disableEdit,
  isSuperTenant,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [isDeleteFile, setIsDeleteFile] = useState(false);

  const handleViewFile = () => {
    setPreviewOpen(true);
  };

  //to close the view preview for file
  const handleClosePreview = () => {
    setPreviewOpen(false);
    onClose();
  };

  const handleViewLink = () => {
    const fileUrl = item?.url;
    if (fileUrl) {
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    } else {
      console.warn("No file URL found to view.");
    }
    onClose();
  };

  const handleView = () => {
    if (type === "FILE") handleViewFile();
    else if (type === "LINK") handleViewLink();
  };

  const handleDeleteClose = () => {
    setIsDeleteFile(false);
    onClose();
  };

  const handleDeleteFileApiCall = async () => {
    try {
      setLoading(true);
      const response = await deleteGuide(item?.id);
      if (response?.status === 200) {
        setAlertMessage("Text Guide archived successfully");
        setAlertType("success");
        handleDeleteClose();
        fetchGuidesData();
      }
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Something went wrong. Please try again later."
      );
      setAlertType("error");
    } finally {
      setLoading(false);
      setAlertOpen(true);
      onClose();
    }
  };
  const handleDeleteFile = async () => {
    setIsDeleteFile(true);
  };

  const handleDownloadFile = async () => {
    try {
      const fileUrl = item?.url || item?.file?.url;
      const fileName = item?.fileName || "download";

      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error("Download failed:", err);
    }
  };

  return (
    <>
      <AttachmentActionsMenu
        open={open}
        anchorEl={anchorEl}
        type={type}
        onClose={onClose}
        onView={handleView}
        onDelete={handleDeleteFile}
        onDownload={handleDownloadFile}
        disableEdit={disableEdit}
        isSuperTenant={isSuperTenant}
      />
      <FilePreviewModal
        open={previewOpen}
        onClose={handleClosePreview}
        fileUrl={item?.url || item?.file?.url}
        fileName={item?.fileName}
        id={item?.id}
        previewLink={item?.previewLink}
        size={item?.file?.size}
      />
      <ConfirmationPopup
        title={`Archive ${type?.toLowerCase()}`}
        note={
          <Typography variant="body2">
            Are you sure you want to archive this(<strong>{item?.title}</strong>
            ) guide? This action cannot be undone.
          </Typography>
        }
        open={isDeleteFile}
        buttonText="Archive"
        onOkay={handleDeleteFileApiCall}
        onCancel={handleDeleteClose}
      />
    </>
  );
};

export default AttachmentActions;
